import BulkManageMobileDrawer from "common/components/BulkManageMobileDrawer";
import type { LinkedInProfile } from "common/types";

import { MANAGE_BLACKLIST_ACTIONS } from "../../../constants";
import BulkRemoveFromBlacklist from "../BulkRemoveFromBlacklist";

import type { Company } from "../../../types";

interface ManageBlacklistProps {
  selectedItems: (Company | LinkedInProfile)[];
  resetSelection: () => void;
  blacklistType: "accounts" | "companies";
}

export default function ManageBlacklist({
  selectedItems,
  resetSelection,
  blacklistType,
}: ManageBlacklistProps) {
  return (
    <BulkManageMobileDrawer
      drawerLabel="blacklist"
      actions={MANAGE_BLACKLIST_ACTIONS}
      selection={selectedItems}
      renderActionComponent={({ onClose, onBack }) => (
        <BulkRemoveFromBlacklist
          selectedItems={selectedItems}
          onBack={onBack}
          onSuccess={() => {
            onClose();
            resetSelection();
          }}
          blacklistType={blacklistType}
        />
      )}
    />
  );
}
